module.exports = __webpack_public_path__ + "static/media/thin-arrowheads-pointing-down.0dc97e25.svg";